import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import './TrainingPages.css';

const POLLEN_BEE_IMG = "https://customer-assets.emergentagent.com/job_bee-booking/artifacts/k8zgjyqb_Pollen%20-%20bHyyve%20Mascot.png";

const Marketplace = () => {
  const navigate = useNavigate();

  return (
    <div className="training-page">
      {/* Banner */}
      <div className="training-banner">
        <div className="banner-content">
          <h1>bHyyve Marketplace</h1>
          <p>Get supplies and equipment at exclusive vendor discounts</p>
        </div>
        <img src={POLLEN_BEE_IMG} alt="Pollen" className="banner-bee" />
      </div>

      {/* Empty State */}
      <div className="empty-state">
        <div className="empty-icon">
          <ShoppingBag size={64} />
        </div>
        <h2>Marketplace Coming Soon</h2>
        <p>The bHyyve Marketplace with exclusive vendor discounts is launching soon. Check back soon!</p>
        <Button 
          className="back-btn"
          onClick={() => navigate('/yourhyyve')}
        >
          <ArrowLeft size={18} />
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default Marketplace;
